// extracted by mini-css-extract-plugin
module.exports =  {"name":"uevTUZKdJOlTt77uWZmm"};